import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { TOKEN_KEY } from 'common/constants';
import { useAppDispatch } from 'common/hook';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { loginWithThirdParty } from 'services/auth.service';
import { getUserInfo } from 'services/user.service';
import { setUser } from 'slices/userSlice';
import { handleError, setItemLocalStorage } from 'utils/helpers';
enum Provider {
    Google = 'google',
    Facebook = 'facebook',
}
const useLogin = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const getUserDetail = async () => {
        try {
            const response = await getUserInfo();
            if (response.success) {
                dispatch(setUser(response.data));
                return response.data;
            }
        } catch (error) {
            handleError(error);
        }
        return null;
    };
    const loginWithGoogle = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            const res = await axios.get(
                'https://www.googleapis.com/oauth2/v3/userinfo',
                {
                    headers: {
                        Authorization: `Bearer ${tokenResponse.access_token}`,
                    },
                }
            );

            const { email, name, picture, sub } = res.data;
            try {
                const loginResponse = await loginWithThirdParty({
                    admin: {
                        email,
                        name,
                        picture,
                        uuid: sub,
                        provider: Provider.Google,
                    },
                });
                const { success, data } = loginResponse;
                if (success) {
                    setItemLocalStorage(TOKEN_KEY, data.token);
                    const userDetail = await getUserDetail();
                    if (userDetail?.attributes?.role === 'accountant') {
                        navigate('/admin/payment');
                    } else {
                        navigate('/');
                    }
                }
            } catch (error) {
                handleError(error);
            }
        },
        onError: () => {
            toast.error('Kết nối đến Google thất bại, vui lòng thử lại.');
        },
        scope: 'openid profile email',
    });
    const onSuccessLoginFacebook = (response: unknown) => {
        console.log('Facebook response:', response);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const loginWithFacebook = async (response: any) => {
        try {
            const res = await loginWithThirdParty({
                admin: {
                    email: response?.email || '',
                    name: response?.name || '',
                    picture: response?.picture?.data.url || '',
                    uuid: response.id || '',
                    provider: Provider.Facebook,
                },
            });
            if (res.success) {
                setItemLocalStorage(TOKEN_KEY, res.data.token);
                const userDetail = await getUserDetail();
                if (userDetail?.attributes?.role === 'accountant') {
                    navigate('/admin/payment');
                } else {
                    navigate('/');
                }
            }
        } catch (error) {
            handleError(error);
        }
    };
    return {
        loginWithGoogle,
        loginWithFacebook,
        onSuccessLoginFacebook,
    };
};
export default useLogin;
